import './App.css';

import OnePagePortfolio from './pages/OnePagePortfolio';
import NotFound from './pages/NotFound';

function App() {
  const isNotFound = window.location.pathname !== '/';

  return (
    <div className="App">
      {isNotFound ? <NotFound /> : <OnePagePortfolio />}
    </div>
  );
}

export default App;
